function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M9 17.066a8 8 0 100-16 8 8 0 000 16z",
  stroke: "#4a74e1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M1.8 1.866h14.4v14.4H1.8z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4 6.666c0 1.323-1.074 2.4-2.4 2.4a2.4 2.4 0 112.4-2.4zm-7.2 6c0-1.6 3.201-2.4 4.8-2.4 1.599 0 4.8.8 4.8 2.4v1.2H4.2v-1.2z",
  fill: "#4a74e1"
});

var SvgStudentsToWatch = function SvgStudentsToWatch(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 17.0659C13.4183 17.0659 17 13.4842 17 9.06592C17 4.64764 13.4183 1.06592 9 1.06592C4.58172 1.06592 1 4.64764 1 9.06592C1 13.4842 4.58172 17.0659 9 17.0659Z' stroke='%234a74e1'/%3E %3Crect opacity='0.01' x='1.79999' y='1.86597' width='14.4' height='14.4' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.4 6.66587C11.4 7.98887 10.326 9.06587 8.99998 9.06587C7.67398 9.06587 6.59998 7.98887 6.59998 6.66587C6.59998 5.33987 7.67398 4.26587 8.99998 4.26587C10.326 4.26587 11.4 5.33987 11.4 6.66587ZM4.19998 12.6659C4.19998 11.0669 7.40098 10.2659 8.99998 10.2659C10.599 10.2659 13.8 11.0669 13.8 12.6659V13.8659H4.19998V12.6659Z' fill='%234a74e1'/%3E %3C/svg%3E";
export { SvgStudentsToWatch as ReactComponent };